<ppl-box-container-with-title [small]="true"
                              title="Email Verification"
                              i18n-title="@@Email_Verification"
                              description="Confirmation Process"
                              i18n-description="@@Confirmation_Process">
  <ppl-error-box *ngIf="error"
                 [ngSwitch]="error.errorCode">
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="error.message; else unknownError">{{ error.message }}</ng-container>
      <ng-template #unknownError>
        <ng-container i18n="@@Unknown_error.">Unknown error.</ng-container>
      </ng-template>
    </ng-container>
  </ppl-error-box>

  <div class="container">
    <div class="description"
         i18n="@@AccountsEmailVerificationDescription">
      Follow the instructions in the email we sent to <br /><strong>{{ email }}</strong><br /> to complete verification.
    </div>

    <div class="resend-container">
      <div class="resend-description"
           i18n="@@You_might_need_to_check_your_spam_folder.">You might need to check your spam folder.</div>
      <div class="buttons">
        <button pplButton
                class="submit-button"
                (click)="onResendEmail()"
                i18n="@@Resend_Email">Resend Email</button>
      </div>
    </div>
  </div>

  <ppl-loading-overlay *ngIf="loading"
                       [large]="true"
                       [visible]="true"
                       [inverse]="true"></ppl-loading-overlay>
</ppl-box-container-with-title>
